<template>
  <div v-if="product" class="product-card__wrapper">
    <div v-click-outside="closeMonitor" :class="['product-card','product-card--has-manufacturer',{ 'product-card--is-expanded': isExpanded(product.id) },{ 'product-card--is-compact': useCompressedView },{ 'product-card--has-fractions': hasFractions }]">
      <div v-if="!useListView" class="product-card__media-left">
        <template v-if="isReplacement">
          <oie-base-label is-type="alternative" :text="tStatic('replacementArticleLabel')"></oie-base-label>
        </template>
        <template v-else>
          <oie-base-checkbox
            v-if="showCompareProducts"
            is-for="product-card"
            :text="tStatic('compareProducts')"
            size="small"
            text-color="gray"
            css-classes="product-card__compare"></oie-base-checkbox>

          <oie-base-label v-if="product.newsSection" is-type="new" :text="product.newsSection"></oie-base-label>
          <oie-base-label v-if="product.section" is-type="info" :text="product.section"></oie-base-label>
          <oie-base-label
            v-if="product.isUniversal"
            is-type="universal"
            :text="tStatic('universalLabel')"
            :tooltip-text="tStatic('universalLabelTooltip')"></oie-base-label>
          <oie-base-label
            v-if="showFitsLabel(product)"
            is-type="info"
            :text="tStatic('fitsLabel')"
            :tooltip-text="tStatic('fitsLabelTooltip')"></oie-base-label>
          <oie-base-label v-if="campaignTag" is-type="campaign" :text="campaignTag"></oie-base-label>
        </template>
      </div>

      <div class="product-card__media">
        <oie-base-image
          :images="product.imageUrl ? `${getAssetPath(product.imageUrl)}?preset=ProductSmall&watermark=OIEWatermarkMedium` : `${getAssetPath('/globalassets/missing404/404.png')}?preset=ProductSmall`"
          :alt-text="stripHtml(product.name)"
          :image-width="productImageSize"
          :image-height="productImageSize"
          class="product-card__image">
        </oie-base-image>

        <oie-base-image
          v-if="useListView && product.productBrand"
          v-tooltip.top="product.productBrandTooltip"
          :images="manufacturerLogo(product.productBrand)"
          :alt-text="product.productBrand"
          class="product-card__manufacturer-logo"></oie-base-image>
        <oie-product-review-mini class="product-card__trustpilot" :sku="product.id"></oie-product-review-mini>
      </div>

      <div :class="['product-card__header', { 'product-card__header--no-labels': !product.newsSection && !product.section && !product.isUniversal && !campaignTag && !showFitsLabel(product) && !isReplacement }]">
        <oie-base-image
          v-if="!useListView && product.productBrand"
          v-tooltip.top="product.productBrandTooltip"
          :images="getAssetPath(manufacturerLogo(product.productBrand))"
          :alt-text="product.productBrand"
          class="product-card__manufacturer-logo"></oie-base-image>

        <!--<div v-if="!useListView && !product.productBrand" class="product-card__manufacturer-logo"></div>-->

        <div v-if="useListView" class="product-card__header-tags">
          <template v-if="isReplacement">
            <oie-base-label is-type="alternative" :text="tStatic('replacementArticleLabel')"></oie-base-label>
          </template>
          <template v-else>
            <oie-base-label v-if="product.newsSection" is-type="new" :text="product.newsSection"></oie-base-label>
            <oie-base-label v-if="product.section" is-type="info" :text="product.section"></oie-base-label>
            <oie-base-label
              v-if="product.isUniversal"
              is-type="universal"
              :text="tStatic('universalLabel')"
              :tooltip-text="tStatic('universalLabelTooltip')"></oie-base-label>
            <oie-base-label
              v-if="showFitsLabel(product)"
              is-type="info"
              :text="tStatic('fitsLabel')"
              :tooltip-text="tStatic('fitsLabelTooltip')"></oie-base-label>
            <oie-base-label v-if="campaignTag" is-type="campaign" :text="campaignTag"></oie-base-label>
          </template>
        </div>

        <h3 class="product-card__name">
          <a :href="getUrlWithVehicle(product)" class="product-card__url" v-html="renderHighlight(product.nameHighlight, product.name)"></a>
        </h3>

        <p v-if="isSingleProduct" class="product-card__article-number">
          {{ tStatic('articleNumberLabel') }}&nbsp;<span v-html="renderHighlight(product.items[0].idHighlight, product.items[0].id)"></span>
        </p>
        <p v-if="isSingleProduct && product.items[0].referenceNumberHighlight" class="product-card__reference-number">
          {{ tStatic('referenceNumberLabel') }}&nbsp;<span v-html="renderHighlight(product.items[0].referenceNumberHighlight)"></span>
        </p>

        <button v-if="(useListView || mq('to-small') ) && Object.keys(product.specification).length > 0 && (typeOfListing=='Product listing' || typeOfListing=='Search Listing')" class="product-card__technical-toggler" @click="toggleActiveTechnicalInformationBlock(product.id)">
          <template v-if="showTechnicalnformation || isTechnicalInformationBlockActive(product.id)">
            {{ tStatic('filterBarTitleHideTechInfo') }}
          </template>

          <template v-else>
            {{ tStatic('filterBarTitleShowTechInfo') }}
          </template>
        </button>
      </div>
      <!-- Add 'Show more/Show less' button to open and close the description block. The button should only be visible if the description is truncated. The button should be hidden if the description is not truncated. -->
      <template>
        <div class="product-card__descriptions-wrapper">
          <p
            v-if="!useCompressedView"
            :class="[
              'product-card__descriptions',
              { 'product-card__descriptions--is-empty': !hasDescription && product.contextDescription === '' },
              { 'product-card__descriptions--no-clamp': (!hasDescription && product.contextDescription !== '') || isDescriptionExpanded },
              { 'product-card__descriptions--is-expanded': isDescriptionExpanded }
            ]">
            <span ref="descriptionSpan">
              <template v-if="!product.currentVehicle">
                <div v-html="renderHighlight(product.descriptionHighlight, showUnhighlightedDescription ? product.description : undefined)"></div>
              </template>

              <template v-if="product.contextDescription">

                <span v-if="getSelectedFractionTypeContexts(product.contextDescriptionDictionary).length > 0" class="product-card__context-description-bold">{{ tStatic('contextDescriptionLabel') }}</span>
                <div v-for="(context, key) in getSelectedFractionTypeContexts(product.contextDescriptionDictionary)" :id="key" :key="key">
                  <b v-if="context.matched">{{ context.text }}</b>
                  <span v-else>{{ context.text }}</span>
                </div>
              </template>
              <button
                v-if="!useCompressedView && isTruncated"
                type="button"
                class="product-card__descriptions-toggle"
                @click="toggleDescriptionExpanded">
                {{ isDescriptionExpanded ? tStatic('productDescriptionShowLessLabel') : tStatic('productDescriptionShowMoreLabel') }}
              </button>
            </span>
          </p>
        </div>
      </template>
      <div class="product-card__actions">
        <div v-if="!isQuoteItem && !isExpiredItem" class="product-card__price-status">
          <p
            v-if="isInternalItem"
            class="caption product-card__internal">
            <oie-base-icon icon="warning"></oie-base-icon>
            <span v-html="tStatic('internalItemContent')"></span>
          </p>
          <oie-product-status
            v-if="isSingleProduct && !useCompressedView"
            :status="getStockStatus(product.items[0])"
            :text="product.items[0].stockDescription"
            css-classes="product-card__status">
          </oie-product-status>
          <oie-product-price
            :current-object="product"
            :is-product="true"
            class="product-card__price"></oie-product-price>
        </div>
        <div
          v-if="isQuoteItem"
          class="caption product-card__quote-info"
          v-html="tStatic('requestQuoteContent')"></div>

        <p v-if="hasFractions && !hasCompleteFraction && showFractionFilter" class="product-card__fractions-information" v-html="tStatic('fractionsAttentionText')"></p>

        <div v-if="!useCompressedView" class="product-card__information-action">
          <template v-if="isSingleProduct">
            <p
              v-if="isExpiredItem"
              class="caption product-card__expired">
              <oie-base-icon icon="warning"></oie-base-icon>
              <span v-html="tStatic('expiredItemContent')"></span>
            </p>
            <template v-else>
              <oie-request-quote-slide-in v-if="isQuoteItem" :item-id="product.items[0].id"></oie-request-quote-slide-in>
              <oie-base-action
                v-else
                v-element-loader="{ endpoint: 'addTocart' }"
                stretch
                theme="secondary"
                size="large"
                :disabled="hasNoPrice || !enableAddToCartButton(product.items[0])"
                @click="addItemToCart(product.items[0].id)">
                {{ tStatic('addToCartButtonLabel') }}
              </oie-base-action>

              <oie-add-to-shopping-list-slide-in :product="product"></oie-add-to-shopping-list-slide-in>

              <oie-notify-me-slide-in
                v-if="showNotifyMe"
                :article-number="product.items[0].id"
                :article-name="`${product.name} ${currentVehicle ? ', ' + currentVehicle.brand + ' ' + currentVehicle.displayName : ''}`">
              </oie-notify-me-slide-in>
            </template>
          </template>

          <template v-else>
            <oie-base-action
              size="large"
              stretch
              :theme="isExpanded(product.id) ? 'outlined-white' : 'primary'"
              @click="toggleVariants(product.id);setTableColumnWidths(product.id)">
              {{ isExpanded(product.id) ? tStatic('showLessArticles') : tStatic('showArticles') }}
            </oie-base-action>
          </template>
        </div>
      </div>
    </div>
    <div v-if="product.replacementProducts && product.replacementProducts.length > 0 && useListViewComputed" class="product-card__replacements-wrapper" :class="{'product-card__replacements-wrapper--expanded': replacementsExpanded}">
      <button
        type="button"
        class="product-card__replacements"

        @click="() => replacementsExpanded = !replacementsExpanded">
        <span>
          <oie-base-icon icon="data-share" size="xs"></oie-base-icon>
          <p>{{ replacementsExpanded ? tStatic('productListReplacementTitleOpen') : tStatic('productListReplacementTitle') }}</p>
        </span>
        <span class="product-card__replacements_toggle">
          <span><oie-base-icon icon="chevron-down" size="s"></oie-base-icon></span>
        </span>
      </button>
      <div v-if="replacementsExpanded" class="product-card__replacements_content">
        <oie-product-list
          v-if="product.replacementProducts.length > 0"
          :products="product.replacementProducts"
          :use-list-view="useListViewComputed"
          :loading="false"
          :type-of-listing="typeOfListing"
          :is-replacement="true"></oie-product-list>

        <div v-if="!product.replacementProducts || product.replacementProducts.length === 0" class="product-list__no-result">
          <p class="product-list__no-result-text">
            {{ t('replacementProductsEmptyText') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// eslint-disable-next-line
import _, { forEach } from 'lodash'
import fractionService from '@/core/fraction-service'
import gtm from '@/core/enhanced-ecommerce-gtm'
import utils from '@/core/utils'
import { renderHighlight, escapeHtml } from '@/core/search-service'
import { productStatuses } from '@/variables/product-statuses'

export default {
  props: {
    showFractionFilter: { type: Boolean, required: false, default: false },
    showFilter: { type: Boolean, required: false, default: false },
    index: {
      type: Number,
      default: undefined
    },
    product: {
      type: Object,
      required: true
    },
    useCompressedView: {
      type: Boolean,
      required: false,
      default: false
    },
    showUnhighlightedDescription: {
      type: Boolean,
      default: false
    },
    typeOfListing: {
      type: String,
      default: ''
    },
    isSearchPage: {
      type: Boolean,
      default: true
    },
    isReplacement: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      showNotificationForm: false,
      replacementsExpanded: false,
      resizeObserver: null,
      resizeTimeout: null,
      isDescriptionExpanded: false,
      isTruncated: false
    }
  },

  computed: {
    ...mapGetters('ui', ['showCompareProducts', 'showTechnicalnformation', 'useListView', 'isTechnicalInformationBlockActive']),
    ...mapGetters(['enableGtm', 'enableArticleWatch', 'currentVehicle', 'longDeliveryTimeLeadTime']),
    ...mapGetters('productVariants', ['isExpanded']),
    hasCompleteFraction() {
      return this.showFilter && fractionService.hasSelectedMatchingFractions(this.product.id).matchesOneOfAll
    },
    hasFractions() {
      return this.showFilter && fractionService.getItemFractions(this.product.id)
    },
    fractions() {
      return this.$store.getters['fractions/allFractions']
    },
    useListViewComputed() {
      if (this.forceListView) { return true }
      if (this.forceGridView) { return false }
      if (this.useGrid && !this.showFilter) {
        return false
      }
      return this.useListView
    },
    hasNoPrice() {
      const item = this.product.items[0]
      if (!item || !item.customerPrice) {
        return true
      }
      return item.customerPrice === null || item.customerPrice === undefined || item.customerPrice.customerPrice === 0 || item.customerPrice.listPrice === 0
    },
    isQuoteItem() {
      return this.isSingleProduct && this.product.items[0].publicationStatusCode === productStatuses.noPrice
    },
    isExpiredItem() {
      return this.isSingleProduct && this.product.items[0].publicationStatusCode === productStatuses.expired
    },
    isInternalItem() {
      return this.isSingleProduct && this.product.items[0].publicationStatusCode === productStatuses.internal
    },
    getRouteCode() {
      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)

      if(params.get('category') !== null) {
        return params.get('category')
      }

      return ''
    },
    productImageSize() {
      return this.useListView ? '82px' : '130px'
    },
    hasSelectedItems() {
      return this.product.items.filter((item) => item.selected).length > 0
    },
    campaignTag () {
      return this.product.items[0] && this.product.items[0].customerPrice && this.product.items[0].customerPrice.campaignTag ? this.product.items[0].customerPrice.campaignTag : ''
    },
    showNotifyMe() {
      if (this.getStockStatus(this.product.items[0]) === 'pb-item-no-remote-stock') {
        return true
      }

      return this.enableArticleWatch && this.isSingleProduct && this.getStockStatus(this.product.items[0]) === 'no-stock'
    },
    isSingleProduct() {
      return this.product.items.length === 1
    },
    hasDescription() {
      return Boolean(this.product.descriptionHighlight || (this.showUnhighlightedDescription && this.product.description))
    }
  },
  watch: {
    'product.description'() {
      this.resetAndCheck()
    },
    'product.descriptionHighlight'() {
      this.resetAndCheck()
    },
    'product.contextDescription'() {
      this.resetAndCheck()
    }
  },
  mounted() {
    this.$nextTick(this.checkTruncation)
    // Set up resize observer to recalculate widths when window resizes
    window.addEventListener('resize', this.handleResize)

    this.subscribe('toggle.articles.all', (open) => {
      if(this.isSingleProduct) {
        return
      }

      if((open && !this.isExpanded(this.product.id)) || (!open && this.isExpanded(this.product.id))) {
        this.toggleVariants(this.product.id)
        if (this.isExpanded(this.product.id)) {
          this.setTableColumnWidths(this.product.id)
        }
      }
    })

    if (this.isExpanded(this.product.id)) {
      this.setTableColumnWidths(this.product.id)
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout)
    }
  },
  methods: {
    renderHighlight,
    escapeHtml,
    ...mapActions('commerce', ['addToCart']),
    ...mapActions('ui', ['toggleActiveTechnicalInformationBlock']),
    ...mapActions('productVariants', ['toggleVariants']),
    getSelectedFractionTypes(key, context) {
      return fractionService.getSelectedFractionTypesForItem(key, context, this.product.id)
    },
    getSelectedFractionTypeContexts(activeContexts) {
      return fractionService.getSelectedFractionTypesForItemProductListing(activeContexts, this.product.id)
    },
    toggleDescriptionExpanded() {
      this.isDescriptionExpanded = !this.isDescriptionExpanded
    },
    checkTruncation() {
      const span = this.$refs.descriptionSpan
      if (!span) return

      // Målar mot det direkta barnet som faktiskt bär line-clamp (div eller context-blocket) och inte mot span själv
      const target = span.firstElementChild
      if (!target) return

      this.isTruncated = target.scrollHeight > target.clientHeight + 1
    },

    resetAndCheck() {
      this.isDescriptionExpanded = false
      this.$nextTick(this.checkTruncation)
    },
    handleResize() {
      this.checkTruncation()
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout)
      }
      this.resizeTimeout = setTimeout(() => {
        if (this.isExpanded(this.product.id)) {
          this.setTableColumnWidths(this.product.id)
        }
      }, 100)
    },

    setTableColumnWidths(productId) {
      this.$nextTick(() => {
        setTimeout(() => {
          const parentElement = document.querySelectorAll(`[data-element-right='${productId}']`)
          const nodeArray = [...parentElement]
          forEach(nodeArray, (el, index) => {
            const width = el.offsetWidth
            if (index === 0) {
              el.closest('table').querySelector('th.product-variants__sticky--right-fixed').style.right = width + 'px'
            }
            el.previousElementSibling.style.right = width + 'px'
          })
        }, 100)
      })
    },
    getUrlWithVehicle(product) {
      if(product.currentVehicle == null) {
        return this.getUrlBasedOnLocation(product)
      }
      const selectedFractions = utils.getQueryStringParam('f')
      const selectedFractionsQueryParam = selectedFractions ? `&f=${encodeURIComponent(selectedFractions)}` : ''

      if(product.currentVehicle !== this.getRouteCode) {
        return this.getUrlBasedOnLocation(product) + '?currentVehicle=' + product.currentVehicle + '&category=' + this.getRouteCode + selectedFractionsQueryParam
      }

      return this.getUrlBasedOnLocation(product) + '?currentVehicle=' + product.currentVehicle + selectedFractionsQueryParam
    },
    getUrlBasedOnLocation(product) {
      const productListing = 'Product listing'
      if(this.typeOfListing !== productListing && this.isSingleProduct) {
        return product.items[0].url
      }
      if(this.typeOfListing !== productListing) {
        return product.url
      }

      var pathArray = window.location.pathname.split('/')
      var newPathname = ''
      for (var i = 3; i <= pathArray.length - 1; i++) {
        newPathname += '/'
        newPathname += pathArray[i]
      }
      if (!newPathname.endsWith('/')) {
        newPathname += '/'
      }
      if(this.isSingleProduct) {
        return `/${this.clientModel.currentMarket}/${this.clientModel.currentLanguage}/product${newPathname}${product.items[0].id}/${product.id}`
      }
      return `/${this.clientModel.currentMarket}/${this.clientModel.currentLanguage}/product${newPathname}${product.id}`
    },
    getStockStatus(item) {
      var number = item.stock
      var threshold = this.getProductFewInStock()
      if (number === undefined) { number = 0 }
      if (threshold === undefined) { threshold = 0 }

      // A ProdBase item that reached the site via BC has been purchased at least once and is
      // stocked, so it is presented as a normal product.
      var showAsProdBaseItem = item.isProdBaseItem && !item.isProdBaseItemViaBC

      if (showAsProdBaseItem && item.prodBaseStatus == 'Remote Price') {
        return 'pb-item-remote-price'
      } else if (showAsProdBaseItem && item.outOfStockForPurchase) {
        // outOfStockForPurchase comes from ProdBasePurchaseRules on the server, so this agrees with
        // the cart's own gate. Deciding it here on BC stock alone is what made an item the vendor
        // had 150 of look sold out (OC-3061).
        return 'pb-item-no-remote-stock'
      } else if (showAsProdBaseItem) {
        return 'pb-item'
      } else if (number >= threshold) {
        return 'in-stock'
      } else if (number > 0) {
        return 'few-stock'
      } else if (item.isOrderItem) {
        return 'is-order-item'
      } else {
        return 'no-stock'
      }
    },
    getStockMessage(item) {
      var number = item.stock
      if (number === undefined) {
        number = 0
      }

      var threshold = this.getProductFewInStock()
      if (threshold === undefined) {
        threshold = 0
      }

      if (number >= threshold) {
        return this.tStatic('stockAvailableLabel')
      } else if (number > 0) {
        return this.tStatic('stockFewLabel')
      } else if (item.isOrderItem) {
        return this.tStatic('stockIsOrderItemLabel')
      } else if (!this.enableAddToCartButton(item)) {
        return this.tStatic('longDeliveryTime')
      } else {
        return this.tStatic('stockNoneLabel')
      }
    },
    manufacturerLogo(manufacturer) {
      if (manufacturer === '' || manufacturer == null) {
        return
      }

      return `/globalassets/brands/${manufacturer}.jpg`
    },
    addItemToCart(itemId) {
      this.addToCart({ itemId, productId: this.product.id, purchasedOnCategory: this.product.analyticsCategory, purchasedToVehicle: this.clientModel.analyticsVehicle }).then((data) => {
        if (this.enableGtm && data.cart) {
          const addedProduct = data.cart.rows.find(x => (x.itemId === itemId) && (x.productId === this.product.id))

          const gtmObject = gtm.createGtmItem(
            addedProduct.itemId,
            addedProduct.displayName,
            addedProduct.item.purchasedToVehicle,
            addedProduct.item.purchasedOnCategory,
            this.formatPriceWithoutCurrency(addedProduct.price),
            1,
            this.typeOfListing)

          gtm.addToCart(gtmObject)
        }
      })
    },
    toggleMonitor() {
      this.showNotificationForm = !this.showNotificationForm
    },
    closeMonitor() {
      this.showNotificationForm = false
    },
    showFitsLabel(product) {
      return product.fractions && product.fractions.length === 0 && !product.isUniversal
    },
    stripHtml: function(html) {
      return html.replace(/<\/?[^>]+(>|$)/g, '')
    },
    enableAddToCartButton(item) {
      if (this.getStockStatus(item) === 'pb-item-remote-price') {
        return true
      }

      if (this.getStockStatus(item) === 'pb-item-no-remote-stock') {
        return false
      }

      if (this.getStockStatus(item) === 'no-stock' && item.deliveryDate && item.deliveryDate.startsWith('2030-01-01') && item.deliveryTime >= this.longDeliveryTimeLeadTime) {
        return false
      }

      return true
    }
  }
}

</script>

<style lang="scss">
    .product-card__wrapper {
      display: flex;
      flex-direction: column;
    }
    .product-card__replacements-wrapper {
      background: color(background-blue-4);
    }
    .product-card__replacements {
      width: 100%;
      cursor: pointer;
      display: flex;
      padding: 1.5rem 1rem;
      align-items: center;
      justify-content: space-between;
      background: transparent;
      border: none;

      span {
        display: flex;
        align-items: center;
      }
      p {
        font-size: inherit !important;
        margin: 0;
        margin-left: 0.5rem;
        @include body-smaller-semi-bold;
      }
    }
    .product-card__replacements_toggle {
      position: relative;
      display: flex;
      align-items: center;
      span {
        transition: transform 0.2s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0;
        border-radius: 50%;
        border: 1px solid #000000;
        width: 1.875rem;
        height: 1.875rem;
      }
    }
    .product-card__replacements-wrapper--expanded {
      .product-card__replacements_toggle span{
        transform: rotate(-180deg);
      }
    }
    .product-card__replacements_content {
      padding: 0 1rem 1rem 1rem;
    }
    .product-card {
      position: relative;
      display: flex;
      flex-direction: column;
      background-color: color(background-white);
      border: 1px solid color(border-gray);
    }

.product-card--has-fractions {
  border-bottom: none;
}

.grid--list .product-card {
  flex-direction: row;
  min-height: 8.25rem;
  height: auto;
}

.product-card--is-expanded {
  border-color: color(border-brand-blue);
}

.grid--list .product-card--is-expanded {
  border-color: color(border-gray);
}

.grid--list .product-card>*:not(:last-child) {
  border-right: 1px solid color(border-gray);
}

.product-card__media {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 13rem;
  padding: measure(half);
}

.grid--list .product-card__media {
  flex-basis: 19.375rem;
  min-height: 9rem;
  height: auto;
}

.product-card__image {
  width: 8.125rem;
  height: 8.125rem;
  object-fit: contain;
}

.grid--list .product-card__image {
  width: 5.125rem;
  height: 5.125rem;
}

.product-card__media-left {
  position: relative;
  margin-top: measure(quarter);
  margin-left: measure(quarter);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 1.875rem;
  z-index: 1;
}

.product-card__media-left>* {
  margin-bottom: measure(eighth);
}

.product-card__manufacturer-logo {
  position: absolute;
  top: measure(quarter);
  right: measure(half);
  max-height: 1.1rem;
  width: auto;
  z-index: 2;
}

.grid--grid .product-card__manufacturer-logo {
  position: relative;
  top: 0;
  right: 0;
  margin-bottom: measure(eighth);
}

.product-card__header {
  padding: measure(eighth) measure(half);
}

.grid--list .product-card__header {
  flex-basis: 16.875rem;
  padding: measure(half);
  border-right: none !important;
}

.grid--list .product-card__header--no-labels {
  padding-top: measure(half);
}

.product-card__header-tags {
  display: flex;
  flex-wrap: wrap;
  gap: measure(eighth);
  margin-bottom: measure(eighth);
}

.product-card__name {
  @include body-bold;
  // height: 3.125rem;
  margin: 0;
  padding: 0;
}

.product-card__url {
  display: block;
  color: color(text);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.product-card__url::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
}

.grid--list .product-card__name {
  height: auto;
  margin-bottom: measure(eighth);
}

.product-card__article-number,
.product-card__reference-number {
  @include caption-semi-bold;
  display: flex;
  align-items: center;
  // height: 1.25rem;
  height: auto;
  color: color(text-blue);
}

.product-card__technical-toggler {
  @include reset-button;
  @include body-smaller;
  display: flex;
  align-items: center;
  margin-top: measure(quarter);
  text-decoration: underline;
  overflow: hidden;
  position: relative;
  z-index: 2;

  &::before {
    @include background-svg(infoCircle);
    content: '';
    display: inline-block;
    width: 1rem;
    height: 1rem;
    margin-right: measure(quarter);
    background-size: contain;
    background-repeat: no-repeat;
  }
}

.product-card__descriptions {
  @include body-smaller;
  position: relative;
  z-index: 3;
  margin: 0;
  padding: measure(eighth) measure(half) measure(quarter) measure(eighth);
  word-break: break-word;
  overflow: hidden;

  @include media(target-ie) {
    &:after {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      height: 4rem;
      background-image: linear-gradient(to bottom, transparent, #ffffff);
    }
  }
}

.product-card__context-description-bold {
  @include body-smaller-semi-bold;
  display: block;
}

.product-card__context-description-emphasis {
  font-weight: bold;
}

.grid--grid .product-card__descriptions {
  @include media(target-ie) {
    height: 5.6875rem !important;
  }
}

.product-card__descriptions--is-empty {
  height: auto;
  padding: 0;
}

.grid--list .product-card__descriptions {
  flex-basis: 16.875rem;
  flex-grow: 1;
  padding: measure(half);
  height: auto;

  @include media(target-ie) {
    height: 10rem;
  }
}

//Clamp sitter på det direkta barnet till span (div eller context-blocket) inte på span själv
.product-card__descriptions > span > :first-child {
  margin-top: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 4;
}

.grid--list .product-card__descriptions> span > :first-child {
  -webkit-line-clamp: 7;
}

.product-card__descriptions.product-card__descriptions--no-clamp>span > :first-child,
.grid--list .product-card__descriptions.product-card__descriptions--no-clamp>span > :first-child {
  -webkit-line-clamp: initial;
}

//Tar bort/döljer IE-gradienten när expanderad, annars ligger den kvar ovanpå den synliga texten
.product-card__descriptions--no-clamp {
  @include media(target-ie) {
    &:after {
      display: none;
    }
  }
}

.product-card__descriptions-toggle {
  background: none;
  border: none;
  padding: 0;
  margin-top: measure(eighth);
  color: var(--color-primary-blue);
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
}

.product-card__descriptions-wrapper {
  display: contents;
}

.product-card__actions {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: measure(half);
  border-top: 1px solid color(border-gray);
  position: relative;
  gap: measure(quarter);
  justify-content: space-between;
}

.product-card--is-compact .product-card__actions {
  padding: measure(half);
}

.grid--list .product-card__actions {
  flex-direction: row;
  flex-basis: 28.125rem;
  flex-shrink: 0;
  align-items: flex-end;
  padding: measure(half);
  border-top: none;
}

.product-card__price-status {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: measure(eighth);
  margin-bottom: measure(quarter);
  padding-right: measure(quarter);
}

.product-card__price {
  margin-top: auto;
}

.product-card--is-compact .product-card__price-status {
  height: auto;
  margin-top: 0;
  margin-bottom: 0;
}

.grid--list .product-card__price-status {
  align-items: flex-start;
  flex-grow: 1;
  height: 100%;
  padding-top: 0;
  margin-bottom: 0;
}

.grid--grid .product-card__price-status {
  flex-grow: 1;
}

.product-card__status {
  margin-bottom: measure(quarter);
}

.product-card__fractions-information {
  @include caption;
  margin-top: 0;
}

.product-card__information-action {
  display: flex;
  align-items: center;
  gap: measure(quarter);
  white-space: nowrap;
  margin-top: auto;
  z-index: 2;
}

.product-card__information-action>*:first-child {
  flex-grow: 1;
}

.product-card__notification-form {
  position: absolute;
  z-index: 11;
  width: calc(100vw - 3.125rem);
  max-width: 21.8rem;

  @include media(to-medium) {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: 0 !important;
    width: unset;
    max-width: unset;
    z-index: 99;
    border: none;
  }
}

.grid--grid .product-card__notification-form {
  margin: measure(quarter) 0 0 0;
}

.grid--list .product-card__notification-form {
  margin: measure(eighth) 0 0 0;
  right: 0;
}

.grid--list .product-card__actions .button {
  flex-basis: auto;
}

.grid--list .product-card__information-action {
  margin-left: auto;
}

.product-card__notify-button {
  width: 100%;
}

.product-card em {
  background-color: #44B1FA;
  font-style: normal;
  color: white;
  padding: 0rem .1rem 0rem .05rem;
}

.product-card em.instant-result__complete_match {
  background-color: #006db6;
  padding: .15rem .4rem .15rem .4rem;
  border-radius: 2px;
}

.product-card__long-delivery-time {
  border: 1px solid #B14932;
  padding: .4rem;
  margin: 0 0 .5rem 0;
}

.product-card__expired {
  display: flex;
  gap: measure(eighth);
  align-items: center;
  padding: measure(eighth);
  background-color: color(background-gray-4);
  border: 1px solid color(border-gray-2);
  flex-grow: 1;
  white-space: normal;
}

.product-card__internal {
  display: flex;
  gap: measure(eighth);
  align-items: center;
  padding: measure(eighth);
  background-color: color(superuser-secondary);
  border: 4px solid color(superuser-primary);
  flex-grow: 1;
  white-space: normal;
  margin-bottom: measure(quarter);
}

.product-card__trustpilot {
  position: absolute;
}

.grid--grid .product-card__trustpilot {
  bottom: 3px;
}

.grid--list .product-card__trustpilot {
  left: 0;
  bottom: 3px;
}
</style>
